module.exports = __webpack_public_path__ + "img/corporationwiki.421e9d70.png";